import React from 'react';
import ContentLoader from 'react-content-loader';
import useWindowSize from "examsbook-react-sdk/custom-hooks/useWindowSize";

/**
 * Live test loader.
 * @returns {*}
 * @constructor
 */
function LiveTestCardLoader() {
    const windowSize = useWindowSize();
    return (
        <div className="mock-test-card test-hover loader-content">
            {windowSize && windowSize.width <= 488 ?
                <ContentLoader
                    height={90}
                    width={230}
                    speed={1}
                    primarycolor="#f3f3f3"
                    secondarycolor="#ecebeb">
                    <rect x="5" y="15" rx="2" ry="2" width="80" height="10"/>
                    <rect x="145" y="15" rx="2" ry="2" width="80" height="10"/>
                    <rect x="5" y="35" rx="2" ry="2" width="220" height="10"/>

                    <rect x="5" y="68" rx="2" ry="2" width="220" height="20"/>
                </ContentLoader> :
                <ContentLoader
                    height={270}
                    width={230}
                    speed={1}
                    primarycolor="#f3f3f3"
                    secondarycolor="#ecebeb">
                    <rect x="5" y="15" rx="5" ry="5" width="80" height="15"/>
                    <rect x="145" y="15" rx="5" ry="5" width="80" height="15"/>
                    <rect x="5" y="75" rx="5" ry="5" width="220" height="14"/>
                    <rect x="5" y="103" rx="5" ry="5" width="220" height="14"/>

                    <rect x="5" y="160" rx="5" ry="5" width="220" height="12"/>
                    <rect x="5" y="185" rx="5" ry="5" width="220" height="12"/>
                    <rect x="5" y="205" rx="5" ry="5" width="220" height="26"/>
                </ContentLoader>
            }
        </div>
    );
}

export default LiveTestCardLoader;
